const clickableElements = new Set(['BUTTON', 'A', 'INPUT']);

export const canClickTarget = (node: HTMLElement): boolean => {
  if (
    node.getAttribute('data-feedcard') ||
    node.getAttribute('data-notificationcard') ||
    node.getAttribute('role') === 'row' ||
    node.getAttribute('data-create-feed-option')
  ) {
    return true;
  }

  if (node.getAttribute('data-reach-custom-checkbox-container') === '') {
    return false;
  }

  if (node.getAttribute('data-reach-listbox-input') === '') {
    return false;
  }

  if (clickableElements.has(node.nodeName)) {
    return false;
  }

  return node.parentElement ? canClickTarget(node.parentElement) : false;
};
